import React from 'react';
import PageLayout from "../../components/PageLayout/PageLayout";
import '../bookpage.css'
import Title from '../../components/Title/Title';

export default function RejoiceInBlessings() {
  return (
    <PageLayout>
      <div className="book-page">
        <Title title="Rejoice and give thanks for all of God’s blessings" />
        <blockquote>
          “Rejoice always…in everything give thanks; for this is God’s will for you in Christ Jesus.” (1 Thessalonians 5:16,18)
        </blockquote>

        <p>Many temptations stem from a lack of contentment or dissatisfaction with our current state. We want more of that or better of this, so we lust, envy, and covet. We don’t like thinking of ourselves as inferior, so we invent reasons why we are better than others and find fault with them, become proud in heart, and treat others with contempt. Drill down until you get to exactly what is it in your life that makes you vulnerable to a particular temptation, what needs there are that are not fulfilled, and ask Christ to meet those needs and give you thankfulness for what you are and have. Are you tempted to get angry with someone? Rejoice and give thanks for them and pray for them, even if they are your enemy, and you will find it much harder to be angry. Do you want something or are concerned about something you lack? Give thanks for what you have, think through all that God has given you, and the temptation to lust or crave for more will fade away. We think others are the problem or our circumstances, but in reality, we are the problem. Rejoicing and giving thanks, singing praises with thankfulness to God, has amazing power to quench temptation. Trust the Lord for every desire and unmet need rather than trying to take things into your own hands or nurturing sinful lusts. Learn to be content with and thankful for what you have, with who you are, and with others in your life, and temptation will lose much of its appeal. Rejoice!</p>
        <br />

        <ul>
          <li>
            <strong>Exult in Jesus Christ; praise Him for what He has done for you and rejoice in Him.</strong><br />
            <em>Psalm 2:11-12, 35:9, 95:1-2, Romans 8:31-39, Colossians 3:15-17</em>
          </li>
          <br />
          <li>
            <strong>Be a thankful, grateful person. Give thanks in everything, for this is God’s will for you.</strong><br />
            <em>Ephesians 5:20, Colossians 3:17, 1 Thessalonians 5:16-18</em>
          </li>
          <br />
          <li>
            <strong>Remember all the good things God has done for you and given you. Don’t focus on what you think you lack. Forget none of God’s blessings.</strong><br />
            <em>Psalm 103:1-5</em>
          </li>
          <br />
          <li>
            <strong>Rejoice always!</strong><br />
            <em>Psalm 34:1-3, 35:28, Philippians 4:4, 1 Thessalonians 5:16-18</em>
          </li>
          <br />
          <li>
            <strong>Sing praises to God with a steadfast heart; do not neglect His praise.</strong><br />
            <em>Psalm 9:1-2, 22:22-24, 40:1-4, 63:3-5, 77:6, 108:1-6, Isaiah 12:5, Ephesians 5:19, Colossians 3:16</em>
          </li>
          <br />
          <li>
            <strong>Give thanks for difficult circumstances, weaknesses, and trials.</strong><br />
            <em>Romans 5:3-5, 8:28, 2 Corinthians 12:7-10, James 1:2-4, 1 Peter 1:6-9</em>
          </li>
        </ul>

      </div>
    </PageLayout>
  );
};
